var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelSubmit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 210,
    height: 115
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cancel-submit_svg__c",
    x1: "154.258%",
    x2: "0%",
    y1: "24.046%",
    y2: "59.452%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F09819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "36.062%",
    stopColor: "#FFD97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFE577"
  })), /*#__PURE__*/React.createElement("path", {
    id: "cancel-submit_svg__a",
    d: "M0 0h210v115H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cancel-submit_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cancel-submit_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#cancel-submit_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDB74",
    d: "M168.864 6.839h11.776c14.534 0-9.799-4.147 0-4.147h53.188c49.62 0 66.313.377 44.699 4.147-21.614 3.77-19.042 1.13 19.801 0 38.843-1.131 20.674 7.785-23.174 7.785-43.849 0-165.972 3.022-142.978 0 15.33-2.014 38.443-3.78 69.341-5.294l-32.653-2.491z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8FCFE",
    d: "M94.474 43.861c-8.494-.25-15.389-1.03-20.684-2.337a5.21 5.21 0 00-7.607-6.938 9.66 9.66 0 00-8.765-5.595 9.66 9.66 0 00-8.827 5.729 5.21 5.21 0 00-8.115 1.673 3.861 3.861 0 00-5.177 2.987c-.484.44-1.047.93-1.687 1.473-2.246 1.906-10.13 2.908-23.656 3.008h84.518z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cancel-submit_svg__c)",
    d: "M0 149c2.866-23.566 17.353-35.349 43.46-35.349 39.162 0 42.378-33.404 68.711-46.57 26.333-13.166 36.121 8.689 64.774-10.97 28.653-19.66 49.772-36.498 80.589-21.123C278.079 45.238 281.48 83.242 267.739 149H0z",
    transform: "translate(-22 2)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104.359 15.544)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#563A07",
    d: "M.355 36.499h74.176v40.149c0 1.12-.907 2.028-2.027 2.028H2.384a2.029 2.029 0 01-2.029-2.028V36.499z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 58.368,
    height: 59.21,
    x: 8.107,
    y: 0.255,
    fill: "#F8FCFE",
    rx: 1.901
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBCF5C",
    d: "M16.391 29.871h41.8v2.535h-41.8zm6.333 6.39h29.133v2.535H22.724zm3.167 6.337h22.8v2.535h-22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD8E17",
    d: "M74.531 36.499v40.149c0 1.12-.907 2.028-2.027 2.028H2.488a.406.406 0 01-.202-.758L74.531 36.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7A11F",
    d: "M.355 36.499v40.149c0 1.12.908 2.028 2.028 2.028H72.4a.405.405 0 00.201-.758L.355 36.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A67823",
    d: "M37.443 57.762L72.6 77.918a.405.405 0 01-.201.758H2.488a.406.406 0 01-.202-.758l35.157-20.156z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(132.5 22.604)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.225,
    cy: 8.847,
    fill: "#CD8E17",
    rx: 8.613,
    ry: 8.618
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 1.267,
    d: "M12.575 5.496l-6.699 6.702M5.875 5.496l6.699 6.702"
  }))))));
}
export default SvgCancelSubmit;